<template>
  <div v-if="visible" class="modal-overlay">
    <div class="modal-container">
      <div class="main-message">
        <img
          class="main-message-icon"
          src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-10Popde6.png"
          alt=""
        />
        {{ type == 1 ? "账号未注册，是否前往注册" : "手机号已注册,是否前往登录" }}
      </div>
      <div class="modal-footer">
        <button class="confirm-btn2" @click="close">关闭</button>
        <button class="confirm-btn" @click="go">
          {{ type == 1 ? "前往注册" : "前往登录" }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CameraBlockedModal",
  props: {
    // visible: {
    //   type: Boolean,
    //   default: true
    // }
  },
  data() {
    return {
      type: 1,  // 1注册，1登录
      originalBodyOverflow: "", // 保存原始 overflow 值
      visible: false,
    };
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        // 弹窗显示：禁止背景滚动
        this.disableBodyScroll();
      } else {
        // 弹窗隐藏：恢复背景滚动
        this.enableBodyScroll();
      }
    },
  },
  mounted() {
    // 如果组件创建时 visible 默认为 true，也需要禁止滚动（但一般初始为 false）
    if (this.visible) {
      this.disableBodyScroll();
    }
  },
  beforeDestroy() {
    // 组件销毁前确保恢复滚动（防止组件被强行移除时滚动仍被禁用）
    this.enableBodyScroll();
  },
  methods: {
    open(type) {
      this.type = type
      this.visible = true;
    },
    go() {
      this.visible = false;
      if (this.type == 1) {
        this.$router.replace("/register");
      } else {
        this.$router.replace("/login");
      }
    },
    close() {
      this.visible = false;
    },
    disableBodyScroll() {
      // 保存当前 body 的 overflow 样式（可能为空或已有值）
      this.originalBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
    },
    enableBodyScroll() {
      // 恢复原来的 overflow 样式
      document.body.style.overflow = this.originalBodyOverflow;
      // 清除保存的值（可选）
      this.originalBodyOverflow = "";
    },
  },
};
</script>

<style lang="scss" scoped>
/* 遮罩层：固定全屏，半透明背景 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.2s ease;
}

/* 弹窗容器：圆角卡片，白色背景 */
.modal-container {
  width: 30rem;
  height: 16rem;
  background-color: #ffffff;
  border-radius: 1.25rem; /* 20px → 1.25rem */
  box-shadow: 0 1.25rem 2.5rem rgba(0, 0, 0, 0.15);
  padding: 3.125rem 0rem 2.75rem;
  box-sizing: border-box;
  animation: scaleIn 0.2s ease;
}

/* 主标题 */
.main-message {
  width: 23rem;
  margin: auto;
  font-weight: 500;
  font-size: 1.625rem;
  color: #101424;
  text-align: left;
  font-style: normal;
  text-transform: none;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 2.375rem;
  margin-bottom: 2.75rem;
  .main-message-icon {
    width: 2.25rem;
    height: 2.25rem;
    margin-right: 0.5rem;
  }
}
.msg{
  width: 23rem;
  margin: auto;
  font-weight: 500;
  font-size: 1.4rem;
  color: #BFC3CFFF;
  margin-bottom: 2rem;
}

/* 底部按钮容器 */
.modal-footer {
  width: 23rem;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* 按钮 */
.confirm-btn {
  width: 10.75rem;
  height: 4.125rem;
  background: #0074fc;
  border-radius: 0.75rem;
  font-weight: 400;
  font-size: 1.5rem;
  color: #fff;
  text-align: center;
  font-style: normal;
  text-transform: none;
  // margin-left: 0.75rem;
}

.confirm-btn2 {
  width: 10.75rem;
  height: 4.125rem;
  background: #fff;
  border-radius: 0.75rem;
  border: 1px solid #bfc3cf;
  font-weight: 400;
  font-size: 1.5rem;
  color: #bfc3cf;
  text-align: center;
  font-style: normal;
  text-transform: none;
}

/* 淡入动画 */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes scaleIn {
  from {
    transform: scale(0.95);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
</style>